import { create } from 'zustand';

type HighlightStore = {
  isOpenHighlightModal: boolean;
  openHighlightModal: () => void;
  highlightId: string;
  setHighlightId: (id: string) => void;
};

export const useHighlightStore = create<HighlightStore>()((set) => ({
  isOpenHighlightModal: false,
  highlightId: '',
  openHighlightModal: () =>
    set((state) => ({ isOpenHighlightModal: !state.isOpenHighlightModal })),
  setHighlightId: (id: string) => set({ highlightId: id }),
}));
